module.exports = __webpack_public_path__ + "img/undTooth12.cb3cb470.png";